import React from "react";
import { MapPin } from "lucide-react";
import { Reveal } from "./Reveal";
import { SITE } from "../data/site";

const PHOTOS = [
  { src: "/studio/heard-seen.jpg", alt: "A place where you are heard, seen and understood" },
  { src: "/studio/calm-space.jpg", alt: "A calm space to reflect, heal and grow" },
  { src: "/studio/studio-wide.jpg", alt: "The counselling studio seating area" },
  { src: "/studio/waiting-balcony.jpg", alt: "The quiet waiting balcony" },
  { src: "/studio/assessment-room.jpg", alt: "The assessment room — a safe space for you" },
];

export const StudioGallery = () => (
  <section id="space" className="bg-[#F2F8E8] py-20 sm:py-28">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="flex flex-wrap items-end justify-between gap-6">
        <div>
          <Reveal><span className="overline">Step inside</span></Reveal>
          <Reveal delay={0.05}>
            <h2 className="section-title text-3xl sm:text-4xl lg:text-5xl mt-4 text-[#20301A]">Your counselling space</h2>
            <p className="text-[#55703F] mt-3 max-w-md">Every corner of the studio is arranged to feel safe, warm and unhurried — so you can arrive exactly as you are.</p>
          </Reveal>
        </div>
        <Reveal delay={0.1}>
          <a data-testid="gallery-maps-link" href={SITE.maps} target="_blank" rel="noreferrer"
            className="inline-flex items-center gap-2 text-sm text-[#3A7D32] border-b-2 border-[#3A7D32] pb-1 hover:gap-3 transition-all">
            <MapPin size={15} /> Visit us in Jubilee Hills
          </a>
        </Reveal>
      </div>
      <div className="columns-1 sm:columns-2 lg:columns-3 gap-4 mt-10" data-testid="studio-gallery">
        {PHOTOS.map((p, i) => (
          <div key={p.src} className="break-inside-avoid mb-4">
            <Reveal delay={0.05 * i}>
              <figure data-testid={`studio-photo-${i}`} className="group overflow-hidden rounded-[24px] soft-shadow border border-[#C9DFAC]">
                <img src={p.src} alt={p.alt} loading="lazy"
                  className="w-full h-auto object-cover transition-transform duration-700 group-hover:scale-[1.03]" />
              </figure>
            </Reveal>
          </div>
        ))}
      </div>
    </div>
  </section>
);
